import ExcelDataSource from "./ExcelDataSource";
import UrlDataSource from "./UrlDataSource";
import GoogleSheetsDataSource from "./GoogleSheetsDataSource";
import type { DataSourceDefinition, DataSourceType } from "../../../types/DataSource";

export const dataSourcesByType = {
  EXCEL: ExcelDataSource,
  URL: UrlDataSource,
  GOOGLE_SPREADSHEET: GoogleSheetsDataSource,
} as never as Record<DataSourceType, DataSourceDefinition<Record<string, unknown>, Record<string, unknown>>>;
